export default __webpack_public_path__ + "static/media/prev-GNSS-Antenna-6.a83cdcf4.png";